import useAppTheme from "@/hooks/use-theme";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { IconButton } from "@mui/material";

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useAppTheme();

  return (
    <IconButton onClick={toggleTheme} size="small">
      {isDark
        ? <LightModeIcon fontSize="small" />
        : <DarkModeIcon fontSize="small" />
      }
    </IconButton>
  );
};

export default ThemeToggle;